import { render, staticRenderFns } from "./PiecesView.vue?vue&type=template&id=07832490"
import script from "./PiecesView.vue?vue&type=script&lang=js"
export * from "./PiecesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports